export const SET_CHECKOUT_LOADING = "SET_CHECKOUT_LOADING=";

export const SET_CHECKOUT_PROFILE_DETAILS = "SET_CHECKOUT_PROFILE_DETAILS=";
